var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.formatDate(_vm.date, _vm.FULL_DATE_AND_TIME_FORMAT)}},[_vm._v(_vm._s(_vm.timeAgo)+" ago")])
}
var staticRenderFns = []

export { render, staticRenderFns }